<header class="fixed-top">
  <nav class="navbar navbar-light navbar-expand-md">
    <div class="container-fluid">
      <a class="navbar-brand" [routerLink]="'matching/projects'">
        <img class="img-fluid float-left" [src]="logoPath()" />
        <p></p>
      </a>
      <div class="collapse navbar-collapse" id="navcol-1">
        <ul class="nav navbar-nav ml-auto">
          <li>
            <app-admin-message-box></app-admin-message-box>
          </li>
          <li ngbDropdown class="d-inline-block dropdown support-dropdown">
            <button class="btn btn-link support-button" id="dropdown_support" ngbDropdownToggle>
              <i class="fa fa-question-circle-o" aria-hidden="true"></i>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdown_support" class="dropdown-menu" role="menu">
              <a class="dropdown-item" role="presentation" target="_blank"
                 href="https://support.qoala.jp/portal/ja/kb/リフ株式会社"
                 [ngbTooltip]="'サポートサイトに移動します。ユーザー様ご自身でアカウント開設が必要です。\nログイン画面右の「未登録の場合：登録する」より登録できます。\nパスワードが不明な場合は「パスワードを忘れた場合：リセットする」より再設定してください。'"
                 tooltipClass="support-tooltip" placement="left" container="body">
                オンラインマニュアル
              </a>
              <a class="dropdown-item" role="presentation" target="_blank"
                 href="https://www.youtube.com/playlist?list=PLYFxJ4AFwF8-MXLGxcYWL7ULRcWBjF5D5">
                動画マニュアル
              </a>
              <a class="dropdown-item" role="presentation" target="_blank"
                 href="https://support.qoala.jp/portal/ja/myarea"
                 [ngbTooltip]="'サポートサイトに移動します。ユーザー様ご自身でアカウント開設が必要です。\nログイン画面右の「未登録の場合：登録する」より登録できます。\nパスワードが不明な場合は「パスワードを忘れた場合：リセットする」より再設定してください。'"
                 tooltipClass="support-tooltip" placement="left" container="body">
                問い合わせ
              </a>
              <a class="dropdown-item" role="presentation" target="_blank"
                 href="https://qoala.youcanbook.me/">
                Zoomサポート予約
              </a>
            </div>
          </li>
          <li>
            <app-theme-switcher></app-theme-switcher>
          </li>
          <li ngbDropdown class="d-inline-block dropdown">
            <button class="btn btn-outline-primary" id="dropdown_user" ngbDropdownToggle>
              &nbsp;
              <i class="fa fa-user-circle account-info"></i>
              <span>{{ this.account.email }}</span>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdown_user" class="dropdown-menu" role="menu">
              <a class="dropdown-item" role="presentation" [routerLink]="'/terms-of-service'">利用規約</a>
              <a class="dropdown-item" role="presentation" [routerLink]="'/privacy-policy-component'">プライパシーポリシー</a>
              <a class="dropdown-item" role="presentation" target="_blank" href="https://www.riff.co.jp/">運営会社</a>
            </div>
          </li>
          <li class="nav-item" role="presentation">
            <a class="nav-link logout-divider" href="#">|</a>
          </li>
          <li class="nav-item" role="presentation">
            <span class="nav-link" href="login.html">
              <button class="btn btn-primary-dark border-0 text-dark logout-link" type="button" (click)="logout()">
                ログアウト
              </button>
            </span>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <ul class="nav nav-tabs primary-color">
    <li class="nav-item">
      <a class="nav-link" [ngClass]="isProjects ? 'menu_active' : 'menu_inactive'" 
         href="/matching/projects" target="_blank" (click)="handleClick($event, '/matching/projects')">
        案件一覧
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [ngClass]="isWorkers ? 'menu_active' : 'menu_inactive'" 
         href="/matching/workers" target="_blank" (click)="handleClick($event, '/matching/workers')">
        人材一覧
      </a>
    </li>
    <li class="nav-item nav-item-reply" *ngIf="isReplyVisible">
      <a class="nav-link" [ngClass]="isReply ? 'menu_active' : 'menu_inactive'" 
         href="/replies" target="_blank" (click)="handleClick($event, '/replies')">
        返信一覧
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [ngClass]="isAuto ? 'menu_active' : 'menu_inactive'" 
         href="/matching/auto" target="_blank" (click)="handleClick($event, '/matching/auto')">
        おすすめ
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [ngClass]="isOffers ? 'menu_active' : 'menu_inactive'" 
         href="/offer" target="_blank" (click)="handleClick($event, '/offer')">
        提案管理
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [ngClass]="isMailRegister ? 'menu_active' : 'menu_inactive'" 
         href="/mail-register" target="_blank" (click)="handleClick($event, '/mail-register')">
        案件人材管理
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [ngClass]="isReport ? 'menu_active' : 'menu_inactive'" 
         href="/report" target="_blank" (click)="handleClick($event, '/report')">
        レポート(β)
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [ngClass]="isSetting ? 'menu_active' : 'menu_inactive'"
         href="/account/setting" target="_blank" (click)="handleClick($event, '/account/setting')">
        設定
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link menu_inactive" [href]="v2FrontUrl" target="_blank">
        新バージョン
      </a>
    </li>
    <li class="nav-item" *ngIf="this.accountService.isAdminUser()">
      <a class="nav-link" [ngClass]="isRegistration ? 'menu_active' : 'menu_inactive'" 
         href="/registration" target="_blank" (click)="handleClick($event, '/registration')">
        ユーザー登録
      </a>
    </li>
    <!-- 閉じるボタン -->
    <li class="nav-exit" *ngIf="isDetailPage()">
      <a class="nav-link" (click)="windowClose()">
        <i class="fa fa-times" style="margin-right:5px;"></i>
      </a>
    </li>
  </ul>
</header>
